module.exports = __webpack_public_path__ + "img/cambodia.72c948be.svg";